//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            items: [
                {
                    url: '/packageA/loan_computer/main',
                    type: 'loan',
                    name: '房贷计算'
                },
                {
                    url: '/packageB/provident_fund/main',
                    type: 'provident',
                    name: '算公积金额度'
                },
                {
                    url: '/check_condition/main',
                    type: 'qualification',
                    name: '资格查询'
                }
            ]
        }
    }
}
